<span>{{obj | json}}</span>
